<template>
    <textfield-screen
            id="firstName"
            :title="$ml.get('setFirstNameReg')"
            v-model="text"
            :is-not-valid="isNotValid"
            :is-not-valid-message="isNotValidMessage"
            :disabledNextButton="disabled"
            :maxlength="30"
            :headerImg="3"
            @next="nextScreen"
            @back="back"
    ></textfield-screen>
</template>

<script>
    import Vue from 'vue'
    import TextfieldScreen from "../../../components/layout/textfield-screen";
    import {default as Profile, filteredName, isWrongName} from "../../../helpers/profile";

    export default {
        name: "setFirstName",
        components: {TextfieldScreen},
        data() {
            return {
                isNotValid: false,
                isNotValidMessage: this.$ml.get('setNameErrorMessage'),
                text: Profile.firstName,
            }
        },
        created() {
            let isMobile = window.innerWidth < 600;
            if (!isMobile) {
                if (Profile.process === 'accessRecovery')
                    this.$router.replace({ name: 'AccessRecoveryFio'});
                else
                    this.$router.replace({ name: 'RegistrationFio'});
            }
        },
        watch: {
            text: function (val) {
                Vue.nextTick(() => {
                    this.text = filteredName(val);
                });
            },
        },
        computed: {
            disabled: function () {
                return this.text.trim().length === 0
            }
        },
        methods: {
            nextScreen: function () {
                if (!this.text.trim())
                    return;
                if (isWrongName(this.text)) {
                    this.isNotValid = true;
                    setTimeout(()=>{
                        this.isNotValid = false;
                    }, 2500);
                    return;
                }
                Profile.setData({firstName: this.text});
                if (Profile.process === 'accessRecovery')
                    this.$router.push({ name: 'AccessRecoveryMiddleName'});
                else
                    this.$router.push({ name: 'RegistrationMiddleName'});
            },
            back: function () {
                this.$router.back();
            }
        },
    }
</script>

<style scoped>

</style>